import { DEFAULT_LOCALE, resolveLocale } from "../../i18n/locale";

/**
 * The language this session renders in.
 *
 * Not a React hook despite the name — it reads a cookie and returns a string,
 * with no state and no effect. The name is kept because it is imported in a
 * dozen places, including at module scope in `i18n/config.js`, where a real
 * hook would be illegal.
 *
 * The parsing and normalization it used to do inline now live in
 * `i18n/locale.js`, which is also what `index.jsx` and the country lookup in
 * `FormRegisterAndIncomplete` call. There were three hand-rolled copies of that
 * cookie read, none of them normalizing, and they had already drifted apart.
 *
 * @returns {string} a tag this app ships
 */
export function useLanguage() {
    const isBackstage = window.location.href.includes("backstage");
    const locale = resolveLocale();

    // Backstage is not offered in English (see AuthLocaleSelect, which also
    // hides the option). A stale en-US cookie from another application must not
    // put an English login screen in front of a backstage user.
    if (isBackstage && locale === "en-US") {
        return DEFAULT_LOCALE;
    }

    return locale;
}
